import axios from 'axios';
import {VorgztUserTO} from 'generated/JavaTO'

export const fetchVorgesetzterUserDataSource = () => axios.get<VorgztUserTO[]>("../json/evoAppsUserInfoDialogController/loadVorg");

export const switchVorgesetzterUserHandler = (vorgesetzterUserId: string) =>
	axios.post("../json/evoAppsUserInfoDialogController/save-vorgesetzter-user", vorgesetzterUserId || undefined)
		.catch(() => {
			alert("Fehler beim Übertragen der Daten. Bitte laden Sie die Seite erneut.");
		});